export const signatureFontFiles = {
  Srisakdi: "srisakdi",
  Sacramento: "sacramento",
  Allura: "allura",
  "Great Vibes": "greatvibes",
  Parisienne: "parisienne",
  Caveat: "caveat",
  Cookie: "cookie",
  Pacifico: "pacifico",
  "Josefin Sans": "josefinsans",
  Ojuju: "ojuju"
};

export const signatureFontOptions = Object.keys(signatureFontFiles).map(
  name => ({
    value: name,
    label: name
  })
);
